<template>
  <resource-collection>
    <template slot-scope="{item}">
      <cart :cart="item"/>
    </template>
  </resource-collection>
</template>

<script>
import Cart from './Cart.vue';
import collection from '../../mixins/collection';
import ResourceCollection from '../resources/ResourceCollection.vue';

export default {
  mixins: [collection],

  components: { Cart, ResourceCollection },

  mounted() {
    Event.listen('cartUpdated', cart => this.update(cart));
    Event.listen('cartCreated', cart => this.prepend(cart));
    Event.listen('cartDeleted', cart => this.remove(cart));
    Event.listen('orderCreated', order => this.remove(order.cart));
  },
};
</script>